import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { httpClient } from '../../../../../core/infra/http/axios-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { Consumables } from './consumables';

export const consumablesService: ServiceCommand<Consumables.Response> =
  new Consumables(httpClient, AUTH_API_ROUTES.CONSUMABLES);

export type { Consumables };
